module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint react/no-did-update-set-state: 0 */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var classNames = __webpack_require__(2);
	var lodashDebounce = __webpack_require__(3);
	var styles = __webpack_require__(4);
	
	var oppositeDirections = {
	    top: 'bottom',
	    bottom: 'top',
	    left: 'right',
	    right: 'left'
	};
	
	function getWindowBounds() {
	    return {
	        top: 0,
	        left: 0,
	        right: window.innerWidth,
	        bottom: window.innerHeight
	    };
	}
	
	function getHalfDimensions(element) {
	    return function (type) {
	        if (element.width && type === 'width') {
	            return element.width / 2;
	        }
	        if (element.height && type === 'height') {
	            return element.height / 2;
	        }
	        return 0;
	    };
	}
	
	var Tooltip = function (_React$Component) {
	    _inherits(Tooltip, _React$Component);
	
	    function Tooltip(props) {
	        _classCallCheck(this, Tooltip);
	
	        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
	
	        _this.state = {
	            top: 0,
	            left: 0,
	            moved: false,
	            flippedFrom: null,
	            tooltipDirection: props.tooltipDirection,
	            isVisible: props.isVisible
	        };
	        return _this;
	    }
	
	    _createClass(Tooltip, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.state.isVisible) {
	                this._adjustPosition();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!this.props.isVisible && nextProps.isVisible) {
	                this.setState({
	                    tooltipDirection: nextProps.tooltipDirection || this.state.tooltipDirection
	                });
	            }
	
	            this.setState({
	                isVisible: nextProps.isVisible
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var _state = this.state,
	                isVisible = _state.isVisible,
	                moved = _state.moved;
	            var debounce = this.props.debounce;
	
	            var adjustPositionDebounced = lodashDebounce(this._adjustPosition, debounce).bind(this);
	            var shouldAdjust = isVisible && !moved;
	
	            if (shouldAdjust && debounce) {
	                adjustPositionDebounced();
	            } else if (shouldAdjust) {
	                this._adjustPosition();
	            } else if (!isVisible && moved) {
	                // make sure the position gets adjusted next time the tooltip is opened
	                this.setState({
	                    moved: false,
	                    flippedFrom: null
	                });
	            }
	        }
	    }, {
	        key: '_getInitialTooltipPosition',
	        value: function _getInitialTooltipPosition(elementRect, tooltipDirection, rootRect) {
	            var _props = this.props,
	                hasTriangle = _props.hasTriangle,
	                triangleSize = _props.triangleSize;
	
	            var triangleSpacing = hasTriangle ? triangleSize : triangleSize / 2;
	
	            var elementDimensions = getHalfDimensions(elementRect);
	            var rootDimensions = getHalfDimensions(rootRect);
	
	            var elementHalfWidth = elementDimensions('width');
	            var elementHalfHeight = elementDimensions('height');
	            var rootHalfWidth = rootDimensions('width');
	            var rootHalfHeight = rootDimensions('height');
	
	            var left = -1 * elementHalfWidth + rootHalfWidth;
	            var top = -1 * elementHalfHeight + rootHalfHeight;
	            var triangleLeft = elementHalfWidth - triangleSpacing;
	            var triangleTop = elementHalfHeight - triangleSize / 2;
	            var spacing = triangleSpacing + 3;
	
	            var positions = {
	                top: {
	                    top: -1 * (elementRect.height + spacing),
	                    left: left,
	                    triangleLeft: triangleLeft
	                },
	                bottom: {
	                    top: rootRect.height + spacing,
	                    left: left,
	                    triangleLeft: triangleLeft
	                },
	                left: {
	                    top: top,
	                    left: -1 * (elementRect.width + spacing),
	                    triangleTop: triangleTop
	                },
	                right: {
	                    top: top,
	                    left: rootRect.width + spacing,
	                    triangleTop: triangleTop
	                }
	            };
	
	            return positions[tooltipDirection];
	        }
	    }, {
	        key: '_getElementsPositions',
	        value: function _getElementsPositions() {
	            return {
	                elementRect: this._tooltip.childNodes[0].getBoundingClientRect(),
	                rootRect: this._tooltip.parentNode.getBoundingClientRect()
	            };
	        }
	
	        /**
	         * Adjusts the position of the tooltip element so that it's centered if possible. If it can't be centered because
	         * it would go offscreen, then offset the position so the whole tooltip is still displayed onscreen.
	         * @param  {Object} elementRect A rectangle indicating the dimensions of the tooltip element
	         */
	
	    }, {
	        key: '_adjustPosition',
	        value: function _adjustPosition() {
	            var _this2 = this;
	
	            if (!this.state.isVisible) {
	                return;
	            }
	
	            var _getElementsPositions2 = this._getElementsPositions(),
	                elementRect = _getElementsPositions2.elementRect,
	                rootRect = _getElementsPositions2.rootRect;
	
	            var tooltipDirection = this.state.tooltipDirection;
	            var _props2 = this.props,
	                thresholds = _props2.positionThresholds,
	                triangleSize = _props2.triangleSize;
	
	            var position = this._getInitialTooltipPosition(elementRect, tooltipDirection, rootRect);
	
	            // determine the area against which we are going to check the thresholds
	            var bounds = this.props.getBounds();
	            var overflowTop = rootRect.top - Math.abs(position.top) - bounds.top;
	            var overflowBottom = bounds.bottom - (rootRect.top + Math.abs(position.top) + elementRect.height);
	            var overflowLeft = rootRect.left + position.left - bounds.left;
	            var overflowRight = bounds.right - (rootRect.left + (position.left + elementRect.width));
	
	            var determineThresholds = {
	                top: function top() {
	                    return overflowTop;
	                },
	                bottom: function bottom() {
	                    return overflowBottom;
	                },
	                left: function left() {
	                    return overflowLeft;
	                },
	                right: function right() {
	                    return overflowRight;
	                }
	            };
	
	            var adjustHorizontal = function adjustHorizontal() {
	                var thresholdsLeft = overflowLeft - thresholds.left;
	                var thresholdsRight = overflowRight - thresholds.right;
	
	                if (overflowLeft < thresholds.left) {
	                    position.left -= thresholdsLeft;
	                    position.triangleLeft += thresholdsLeft;
	                    _this2.props.onThresholdPassed();
	                }
	
	                if (overflowRight < thresholds.right) {
	                    position.left += thresholdsRight;
	                    position.triangleLeft -= thresholdsRight;
	                    _this2.props.onThresholdPassed();
	                }
	            };
	
	            var adjustVertical = function adjustVertical() {
	                var thresholdsTop = overflowTop - thresholds.top;
	                var thresholdsBottom = overflowBottom + elementRect.height / 2;
	                var triangleHalfSize = triangleSize / 2;
	                var overflowTriangleTop = elementRect.height - triangleHalfSize - triangleSize;
	
	                if (overflowTop < thresholds.top) {
	                    position.top -= thresholdsTop;
	                    position.triangleTop += thresholdsTop;
	                    _this2.props.onThresholdPassed();
	                }
	
	                if (thresholdsBottom < thresholds.bottom) {
	                    position.top += thresholdsBottom + thresholds.bottom;
	                    position.triangleTop -= thresholdsBottom + thresholds.bottom;
	                    _this2.props.onThresholdPassed();
	                }
	
	                if (position.triangleTop <= 0) {
	                    position.triangleTop = triangleHalfSize;
	                } else if (position.triangleTop > overflowTriangleTop) {
	                    position.triangleTop = overflowTriangleTop;
	                }
	            };
	
	            var changeDirection = function changeDirection(direction) {
	                var oldState = tooltipDirection;
	                _this2.setState({
	                    tooltipDirection: direction,
	                    moved: false,
	                    flippedFrom: oldState
	                });
	                _this2.props.onThresholdPassed();
	            };
	
	            /*
	                This has the effect that if the tooltip doesn't fit on both the top and the bottom, we default to
	                displaying it on the top as per the spec
	             */
	            var canFlip = function canFlip() {
	                // if the previous tooltip direction was 'top' (i.e. it's on the bottom now), we can still flip back to the top
	                return !_this2.props.lockDirection && (!_this2.state.flippedFrom || _this2.state.flippedFrom === 'top');
	            };
	
	            var changeDirectionIfNecessary = function changeDirectionIfNecessary(changed, direction) {
	                if (!changed && canFlip() && tooltipDirection === direction) {
	                    var overflow = determineThresholds[direction]();
	                    if (overflow < thresholds[direction]) {
	                        changeDirection(oppositeDirections[direction]);
	                        changed = true;
	                    }
	                }
	                return changed;
	            };
	
	            var verticalOrientations = ['top', 'bottom'];
	            var horizontalOrientations = ['left', 'right'];
	
	            /*
	                If the tooltip is displayed on the top or bottom, adjust the horizontal position so it's all displayed inside
	                the window and flip it from top->bottom or vice-versa if necessary
	             */
	            if (verticalOrientations.indexOf(tooltipDirection) >= 0) {
	                adjustHorizontal();
	                if (verticalOrientations.reduce(changeDirectionIfNecessary, false)) {
	                    return;
	                }
	            }
	
	            /*
	                If the tooltip is displayed on the left or right flip it from left->right or vice-versa if necessary
	             */
	            if (horizontalOrientations.indexOf(tooltipDirection) >= 0) {
	                adjustVertical();
	                if (horizontalOrientations.reduce(changeDirectionIfNecessary, false)) {
	                    return;
	                }
	            }
	
	            this.setState(_extends({
	                moved: true
	            }, position));
	        }
	
	        /**
	         * Renders the tooltip contents if this.state.isVisible is true
	         * @param  {Object} style         The style of the tooltip container
	         */
	
	    }, {
	        key: '_renderContents',
	        value: function _renderContents(containerStyle) {
	            var _props3 = this.props,
	                className = _props3.className,
	                children = _props3.children,
	                hasTriangle = _props3.hasTriangle,
	                hasClose = _props3.hasClose,
	                containerClass = _props3.containerClass,
	                onClick = _props3.onClick;
	            var tooltipDirection = this.state.tooltipDirection;
	
	            var tooltipClass = classNames(styles[tooltipDirection], styles.container, className);
	            var tooltipInnerClass = classNames(styles.inner, containerClass);
	
	            return React.createElement(
	                'div',
	                { className: tooltipClass, style: containerStyle, onClick: onClick },
	                React.createElement(
	                    'div',
	                    { className: tooltipInnerClass },
	                    children
	                ),
	                hasTriangle ? this._renderTriangle(tooltipDirection) : null,
	                hasClose ? this._renderClose() : null
	            );
	        }
	
	        /**
	         * Renders the tooltip triangle if this.props.hasTriangle is true
	         */
	
	    }, {
	        key: '_renderTriangle',
	        value: function _renderTriangle(direction) {
	            var _props4 = this.props,
	                triangleSize = _props4.triangleSize,
	                triangleClass = _props4.triangleClass;
	            var _state2 = this.state,
	                left = _state2.triangleLeft,
	                top = _state2.triangleTop;
	
	            var triangleClassName = classNames(styles.triangle, triangleClass);
	            var triangleDirectionPosition = -1 * triangleSize;
	
	            var triangleStyle = {
	                top: {
	                    left: left,
	                    bottom: triangleDirectionPosition + 1
	                },
	                bottom: {
	                    left: left,
	                    top: triangleDirectionPosition + 1
	                },
	                left: {
	                    top: top,
	                    right: triangleDirectionPosition - 4
	                },
	                right: {
	                    top: top,
	                    left: triangleDirectionPosition - 4
	                }
	            };
	
	            return React.createElement(
	                'svg',
	                { className: triangleClassName, style: triangleStyle[direction], width: triangleSize * 2, height: triangleSize, viewBox: '0 0 20 10' },
	                React.createElement('polygon', { points: '9.65217424 0 19.3043485 9.25000032 0 9.25000032' }),
	                React.createElement('polygon', { className: styles.triangleStroke, strokeLinecap: 'square', points: '9.65723177 0.421508695 9.66228432 0.416666667 9.6572594 0.421535177 18.4448983 8.84302248 18.3478314 8.84165446 9.65723177 0.42156195 0.966632149 8.84165446 0.869565217 8.84302248 9.65720414 0.421535177 9.65217922 0.416666667' })
	            );
	        }
	
	        /**
	         * Renders the tooltip close if this.props.hasClose is true
	         */
	
	    }, {
	        key: '_renderClose',
	        value: function _renderClose() {
	            var _props5 = this.props,
	                closeClass = _props5.closeClass,
	                onCloseClick = _props5.onCloseClick;
	
	            var closeClassName = classNames(styles.close, closeClass);
	
	            return React.createElement(
	                'a',
	                { href: '#0', onClick: onCloseClick },
	                React.createElement(
	                    'svg',
	                    { className: closeClassName, viewBox: '0 0 25 25' },
	                    React.createElement('path', { d: 'M13.7001992,12.5 L24.7011952,23.500996 C25.0348606,23.8346614 25.0348606,24.37251 24.7011952,24.7011952 C24.3675299,25.0298805 23.8296813,25.0348606 23.500996,24.7011952 L12.5,13.7001992 L1.49900398,24.7011952 C1.16533865,25.0348606 0.62749004,25.0348606 0.298804781,24.7011952 C-0.0298804781,24.3675299 -0.0348605578,23.8296813 0.298804781,23.500996 L11.2998008,12.5 L0.298804781,1.49900398 C-0.0348605578,1.16533865 -0.0348605578,0.62749004 0.298804781,0.298804781 C0.63247012,-0.0298804781 1.17031873,-0.0348605578 1.49900398,0.298804781 L12.5,11.2998008 L23.500996,0.298804781 C23.8346614,-0.0348605578 24.37251,-0.0348605578 24.7011952,0.298804781 C25.0298805,0.63247012 25.0348606,1.17031873 24.7011952,1.49900398 L13.7001992,12.5 L13.7001992,12.5 Z' })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _state3 = this.state,
	                top = _state3.top,
	                left = _state3.left;
	
	            var containerStyle = { top: top, left: left };
	
	            return React.createElement(
	                'div',
	                { ref: function ref(tooltip) {
	                        _this3._tooltip = tooltip;
	                    } },
	                this.state.isVisible ? this._renderContents(containerStyle) : null
	            );
	        }
	    }]);
	
	    return Tooltip;
	}(React.Component);
	
	Tooltip.propTypes = {
	    children: React.PropTypes.node,
	    tooltipDirection: React.PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
	    lockDirection: React.PropTypes.bool,
	
	    isVisible: React.PropTypes.bool,
	    hasTriangle: React.PropTypes.bool,
	    hasClose: React.PropTypes.bool,
	
	    className: React.PropTypes.string,
	    containerClass: React.PropTypes.string,
	    triangleClass: React.PropTypes.string,
	    closeClass: React.PropTypes.string,
	
	    debounce: React.PropTypes.number,
	    triangleSize: React.PropTypes.number,
	    positionThresholds: React.PropTypes.shape({
	        top: React.PropTypes.number,
	        bottom: React.PropTypes.number,
	        left: React.PropTypes.number,
	        right: React.PropTypes.number
	    }),
	
	    onClick: React.PropTypes.func,
	    onCloseClick: React.PropTypes.func,
	    onThresholdPassed: React.PropTypes.func,
	    getBounds: React.PropTypes.func
	};
	
	Tooltip.defaultProps = {
	    className: '',
	    containerClass: styles.defaultStyle,
	    triangleClass: styles.defaultTriangle,
	    debounce: 0,
	    triangleSize: 10,
	    tooltipDirection: 'top',
	    lockDirection: false,
	    positionThresholds: {
	        top: 10,
	        bottom: 10,
	        left: 10,
	        right: 10
	    },
	    onClick: function onClick() {},
	    onCloseClick: function onCloseClick() {},
	    onThresholdPassed: function onThresholdPassed() {},
	    getBounds: getWindowBounds,
	    hasTriangle: true,
	    hasClose: false
	};
	
	module.exports = Tooltip;

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = require("react");

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = require("lodash.debounce");

/***/ },
/* 4 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"defaultStyle":"Tooltip__defaultStyle___2PHGC","defaultClose":"Tooltip__defaultClose___3C4eQ","defaultTriangle":"Tooltip__defaultTriangle___2yE9C","container":"Tooltip__container___1iGSw","inner":"Tooltip__inner___34nOg","svg":"Tooltip__svg___1D5qj","close":"Tooltip__close___39mNB Tooltip__svg___1D5qj","triangle":"Tooltip__triangle___XBkZH Tooltip__svg___1D5qj","triangleStroke":"Tooltip__triangleStroke___1qO6p","top":"Tooltip__top___3PYiq","left":"Tooltip__left___2ocL0","right":"Tooltip__right___1Jius"};

/***/ }
/******/ ]);
//# sourceMappingURL=Tooltip.js.map


//////////////////
// WEBPACK FOOTER
// ./~/dibs-react-tooltip/dist/Tooltip.js
// module id = 350
// module chunks = 5 7 8 9 10 11 12 13 14 15 16 17 18 19 21 22 23 24 27 31 32 33 57 58